/**
 * Icon and colours per questionnaire template type for the Templates list
 * (badge, row icon and the type filter). Labels come from
 * {@link QUESTIONNAIRE_TYPE_LABELS} so every picker reads the same.
 */
import {
  Award, Briefcase, ClipboardList, DollarSign, FileText, Globe, Leaf, Lock, Settings, Shield, UserPlus,
} from 'lucide-react';
import { QUESTIONNAIRE_TYPE_LABELS } from '../../lib/questionnaireLabels';

export interface TemplateTypeStyle {
  icon: React.ReactNode;
  bg: string;
  text: string;
  label: string;
}

const icon = (Icon: typeof Shield) => <Icon className="h-3.5 w-3.5" />;

const style = (type: string, Icon: typeof Shield, bg: string, text: string): TemplateTypeStyle => ({
  icon: icon(Icon), bg, text, label: QUESTIONNAIRE_TYPE_LABELS[type] ?? type,
});

/** Every type the backend offers first, then the ones older templates may carry. */
export const TYPE_CONFIG: Record<string, TemplateTypeStyle> = {
  onboarding: style('onboarding', UserPlus, 'bg-sky-50', 'text-sky-700'),
  standard: style('standard', FileText, 'bg-slate-50', 'text-slate-700'),
  compliance: style('compliance', Shield, 'bg-blue-50', 'text-blue-700'),
  audit: style('audit', ClipboardList, 'bg-indigo-50', 'text-indigo-700'),
  esg: style('esg', Globe, 'bg-green-50', 'text-green-700'),
  quality: style('quality', Award, 'bg-purple-50', 'text-purple-700'),
  custom: style('custom', Settings, 'bg-gray-50', 'text-gray-700'),
  capability: style('capability', Briefcase, 'bg-orange-50', 'text-orange-700'),
  financial: style('financial', DollarSign, 'bg-emerald-50', 'text-emerald-700'),
  sustainability: style('sustainability', Leaf, 'bg-teal-50', 'text-teal-700'),
  security: style('security', Lock, 'bg-red-50', 'text-red-700'),
};
